/**
 * User Onboarding Slides
 * 
 * Content for the user onboarding carousel shown on first app launch.
 */

import type { OnboardingSlide } from "../types";

/**
 * User onboarding slides (4 slides)
 */
export const USER_ONBOARDING_SLIDES: OnboardingSlide[] = [
  {
    id: "welcome",
    title: "Welkom bij de Staatsen App",
    description: "De familie app voor alle Staatsen leden. Chat, speel en beleef samen onvergetelijke momenten.",
    lottieSource: require("@/assets/explainer/explainer_1.json"),
    icon: "home",
  },
  {
    id: "features",
    title: "Ontdek de App",
    description: "💬 Chat met familie\n🎮 Speel spellen & verdien punten\n📅 Agenda met verjaardagen & evenementen\n📸 Deel foto's",
    lottieSource: require("@/assets/explainer/explainer_6.json"),
    icon: "apps",
  },
  {
    id: "guardian",
    title: "Voor Jong & Oud",
    description: "Kinderen zonder telefoon kunnen ook meedoen! Ouders of aangewezen guardians kunnen switched als user om het kind te laten spelen.",
    lottieSource: require("@/assets/explainer/explainer_8.json"),
    icon: "people",
  },
  {
    id: "rules",
    title: "Verantwoord Gebruik",
    description: "Deze app is ook voor kinderen. Wees respectvol in berichten en foto's. Berichten en foto's worden gecontroleerd door beheerders.",
    lottieSource: require("@/assets/explainer/explainer_7.json"),
    icon: "shield-checkmark",
  },
];

/**
 * Final button text for user onboarding
 */
export const USER_ONBOARDING_BUTTON_TEXT = "Ik begrijp het";

